export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.ab6c20eb.jpg";